/*
|--------------------------------------------------------------------------
| Site Forms: Newsletter form sending data from PostUp form to SFMC
|--------------------------------------------------------------------------
*/

__gh__webApp.siteForms.postupNewsletter = {
	
	/**
	 * Initialize form
	 */
	"init": function(){
		this.bindEvents();
	},

	
	"bindEvents":function(){
		var $form = $('.newsletterRegister').find('form');
		if (!$form.length) {return;}

		$form.submit(function(){
			event.preventDefault();

			//Check for Daily Newsletter opt-in
			var dailyHeadlinesChecked = $('#DailyHeadlines').prop('checked');
			$("#DailyHeadlines").change(function() {
				if(this.checked) {
					dailyHeadlinesChecked = true
				} else {
					dailyHeadlinesChecked = false
				}
			});
			if (dailyHeadlinesChecked == false) {return;}

			//SFMC stuff
			var thisObject				= __gh__webApp.siteForms.postupNewsletter,
				trackNewsletterSignUp 	= __gh__webApp.utilities.tracker.trackNewsletterSignUp,
				sfEmail 				= document.getElementById('Email').value,
				sfProdCode				= __gh__coreData["3rdPartyData"].analytics.salesforce.prodcode,
				sfData  				= "[{\"Keys\":{\"PROD_CODE\":\""+sfProdCode+"\",\"Email_Address\":\""+sfEmail+"\"},\"Values\":{\"Email_Address\":\""+sfEmail+"\"}}]";
		
		    $.ajax({
		        type: 'post',
		        url: 'http://redesign.gatehousemedia.com/david/salesforceRegister.php',
		        data: {"sfData":sfData},
		        success: function( data ) {
		            if(data.indexOf("errorcode") > -1) {
						console.log("payload error: "+data);
		            } else {
						console.log("payload: "+data);
		            }
		        }
		    });

			console.log("Form Submitted to SFMC (postupnewsletter.js)");

		})
	}
	
};
